import React, { useEffect, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import styles from "./heroBanner.scss";
import "./customDots.css";
import ResponsiveImg from "@tw/shared-ui-components/lib/components/responsiveImg/responsiveImg";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
import useQueryParams from "../../../hooks/useQueryParams";
import { useSelector } from "react-redux";
const heroBanner = ({ banners }) => {
  const breakpoint = useSelector((state) => state.breakpoint);
  const sliderRef = useRef(null);
  const queryParams = useQueryParams();
  const [UTM_PATAMS_1, setUTM_PATAMS_1] = useState('')
  const [UTM_PATAMS_2, setUTM_PATAMS_2] = useState('')
  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0, true);
    }
  }, [banners, sliderRef.current]);
  useEffect(() => {
    setUTM_PATAMS_1(getQueryUTMString("&"))
    setUTM_PATAMS_2(getQueryUTMString("?"))
  }, [queryParams])
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: (dots) => <ul>{dots}</ul>,
    customPaging: () => (
      <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
    ),
  };

  if (!banners) {
    return null;
  }
  return (
    <React.Fragment>
      <div className={styles.hero_banner_wrapper + " hero_banner"}>
        <Slider {...settings} ref={sliderRef}>
          {banners.map((banner, i) => (
            <a
              href={banner?.link?.href ?
                banner?.link?.href.includes("?") ?
                  `${banner?.link?.href}${UTM_PATAMS_1}` : `${banner?.link?.href}${UTM_PATAMS_2}`
                :
                "#"}
              title={banner.link?.title}
              target={banner.link?.tabConfig === "new" ? "_blank" : ""}
              rel="noreferrer"
              className={styles.hero_banner}
              key={i}
              onDragStart={(e) => e.preventDefault()}
            >
              <div className={styles.image_area}>
                {/* <img className={styles.img} src={banner.image} /> */}
                <div
                  className={`${styles.img} ${!banner?.displayDescription ? styles["withImageOnly"] : ""
                    }`}
                >
                  {/* <img src={banner.image} /> */}

                  {breakpoint === "sm" || breakpoint === "xs" ? (
                    <ResponsiveImg
                      src={banner?.mobileImage}
                      showFallbackImg
                      bestQuality
                    />
                  ) : (
                    <ResponsiveImg
                      src={banner?.image}
                      showFallbackImg
                      bestQuality
                    />
                  )}
                </div>
              </div>
              {banner.displayDescription ? (
                <div
                  className={`${styles.description_wrapper}`}
                  style={{ backgroundColor: banner.backgroundColor }}
                >
                  <div className={styles.inner_wrapper}>
                    <div
                      className={styles.heading}
                      style={{
                        color: banner?.titleFontColor,
                      }}
                    >
                      {banner.title}
                    </div>
                    <div
                      className={styles.sub_heading}
                      style={{
                        color: banner?.subTitleFontColor,
                      }}
                    >
                      {banner.subTitle}
                    </div>
                  </div>
                </div>
              ) : null}
            </a>
          ))}
        </Slider>
      </div>
    </React.Fragment>
  );
};

{
  /* <div className={styles.image_area}>
              <img
                className={styles.img}
                src={heroBanner.bannerImageList[0].banner_image_data.url.url}
              />
            </div>
            <div className={`${styles.description_wrapper}`}>
              <div className={styles.inner_wrapper}>
                <div className={styles.heading}>{heroBanner.title}</div>
                <div className={styles.sub_heading}>{heroBanner.subTitle}</div>
              </div>
            </div>
          </div>
          <div className={styles.hero_banner}>
            <div className={styles.image_area}>
              <img
                className={styles.img}
                src={heroBanner.bannerImageList[0].banner_image_data.url.url}
              />
            </div>
            <div className={`${styles.description_wrapper}`}>
              <div className={styles.inner_wrapper}>
                <div className={styles.heading}>{heroBanner.title}</div>
                <div className={styles.sub_heading}>{heroBanner.subTitle}</div>
              </div>
            </div>
          </div> */
}

export default heroBanner;
